import "./PatKnowledgeCentre.module.css";
import Header from "@/reusable_sections/Header";
import KnowledgeCentre from "./sections/KnowledgeCentre";
import FormatsGrid from "./sections/FormatsGrid";
import RelatedSolutions from "./sections/RelatedSolutions";
import Footer from "@/reusable_sections/Footer";
export default function PatKnowledgeCentrePage() {
  return <div>
      <Header />
      <KnowledgeCentre />
      <FormatsGrid />
      <RelatedSolutions />
      <Footer />
    </div>;
}